import { useState } from "react";

export const useSignUpSuccess = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccess = () => {
    setIsSuccess(true);
  };

  const handleClose = () => {
    setIsSuccess(false);
  };

  return {
    isSuccess,
    handleSuccess,
    handleClose,
  };
};
